/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmenityCollectionResponse } from '../../models/amenity-collection-response';

export interface GetTenantAmenities$Params {
  'Active-Tenant-Identifier': string;
  page?: number;
  size?: number;
}

export function getTenantAmenities(http: HttpClient, rootUrl: string, params: GetTenantAmenities$Params, context?: HttpContext): Observable<StrictHttpResponse<AmenityCollectionResponse>> {
  const rb = new RequestBuilder(rootUrl, getTenantAmenities.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmenityCollectionResponse>;
    })
  );
}

getTenantAmenities.PATH = '/tenant-amenities';
